import { getMakeupHairApiBaseUrl } from '../../makeuphair/utils/apiConfig';
import { kioskAuthHeaders } from '../../makeuphair/utils/kioskAuthHeaders';
import { getFranchiseOrganizationId } from '../../shared/franchiseFlowAuth';

function base() {
  return `${getMakeupHairApiBaseUrl().replace(/\/$/, '')}/api/makeup-flux-prompt-v3`;
}

function withOrg(path) {
  const orgId = getFranchiseOrganizationId();
  if (!orgId) return path;
  const join = path.includes('?') ? '&' : '?';
  return `${path}${join}organization_id=${encodeURIComponent(String(orgId))}`;
}

export async function fetchMakeupFluxPromptV3BuildInfo() {
  const res = await fetch(`${base()}/build-info`, { credentials: 'include' });
  return res.json();
}

/** Gemma skin + lip profiles for Auto foundation / preset resolve. */
export async function analyzeMakeupFluxPromptV3(image, preset, useGemma = true) {
  const res = await fetch(`${base()}${withOrg('/analyze')}`, {
    method: 'POST',
    credentials: 'include',
    headers: kioskAuthHeaders({ 'Content-Type': 'application/json' }),
    body: JSON.stringify({ image, preset, use_gemma: useGemma }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || data?.success === false) {
    throw new Error(data?.error || data?.code || `Analyze failed (${res.status})`);
  }
  return data;
}

export async function resolveMakeupFluxPromptV3({
  preset,
  skinProfile,
  lipProfile,
  overrides,
  fluxLookId,
}) {
  const res = await fetch(`${base()}${withOrg('/resolve')}`, {
    method: 'POST',
    credentials: 'include',
    headers: kioskAuthHeaders({ 'Content-Type': 'application/json' }),
    body: JSON.stringify({
      preset,
      skin_profile: skinProfile,
      lip_profile: lipProfile,
      overrides,
      flux_look_id: fluxLookId,
    }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || data?.success === false) {
    throw new Error(data?.error || data?.code || `Resolve failed (${res.status})`);
  }
  return data.resolved_config;
}

export async function generateMakeupFluxPromptV3(body = {}) {
  const {
    image,
    makeupLab,
    makeup_lab,
    wrapIdentity = true,
    wrap_identity,
    applyAutoFoundation = true,
    apply_auto_foundation,
    presetId,
    preset_id,
    timeOfUse,
    time_of_use,
    skinTone,
    skin_tone,
    bridalOrnamentStyle,
    bridal_ornament_style,
    bridalLookId,
    bridal_look_id,
    usePresetPromptBoost,
    use_preset_prompt_boost,
    customLabEdits,
    custom_lab_edits,
  } = body;
  const payload = {
    image,
    makeup_lab: makeup_lab || makeupLab,
    wrap_identity: wrap_identity ?? wrapIdentity,
    apply_auto_foundation: apply_auto_foundation ?? applyAutoFoundation,
    generation_nonce: Date.now(),
    preset_id: preset_id ?? presetId,
    use_preset_prompt_boost: use_preset_prompt_boost ?? usePresetPromptBoost,
    custom_lab_edits: custom_lab_edits ?? customLabEdits,
    time_of_use: time_of_use ?? timeOfUse,
    skin_tone: skin_tone ?? skinTone,
    bridal_ornament_style: bridal_ornament_style ?? bridalOrnamentStyle,
    bridal_look_id: bridal_look_id ?? bridalLookId,
  };
  Object.keys(payload).forEach((k) => {
    if (payload[k] === undefined) delete payload[k];
  });
  const res = await fetch(`${base()}${withOrg('/generate')}`, {
    method: 'POST',
    credentials: 'include',
    cache: 'no-store',
    headers: kioskAuthHeaders({ 'Content-Type': 'application/json' }),
    body: JSON.stringify(payload),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || !data.success) {
    const msg = data.error || data.code || `HTTP ${res.status}`;
    throw new Error(msg);
  }
  return data;
}
